import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { IonButton } from '@ionic/angular';

@Component({
  selector: 'bepatient-onboarding-button-v2',
  templateUrl: './onboarding-button-v2.component.html',
  styleUrls: ['./onboarding-button-v2.component.scss'],
  standalone: false
})
export class OnboardingButtonV2Component {
  @Input() disabled: boolean;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  @ViewChild(IonButton, { read: ElementRef, static: true })
  buttonElement: ElementRef;

  @Input() set color(v: string) {
    this.applyColor(v);
  }

  @Input() set bgColor(v: string) {
    this.applyBgColor(v);
  }

  private applyColor(color: string): void {
    const style =
      this.buttonElement &&
      this.buttonElement.nativeElement &&
      this.buttonElement.nativeElement.style;
    if (style) {
      style.setProperty('--color', color);
      style.setProperty('--background-focused', color);
      style.setProperty('--background-activated', color);
      style.setProperty('--background-hover', color);
      style.setProperty('--background-hover-opacity', 1);
    }
  }

  private applyBgColor(color: string): void {
    const style =
      this.buttonElement &&
      this.buttonElement.nativeElement &&
      this.buttonElement.nativeElement.style;
    if (style) {
      style.setProperty('--background', color);
      style.setProperty('--color-activated', color);
      style.setProperty('--color-focused', color);
      style.setProperty('--color-hover', color);
    }
  }
}
